import axios from "axios";
import React, { useEffect, useState } from "react";
import { Fade } from "react-awesome-reveal";
import Skeleton from "react-loading-skeleton";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import './styles.scss';

const Default = () => {
    const { slug } = useParams();
    const [pageContent, setPageContent] = useState(null);
    const [isFetching, setIsFetching] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
        // document.title = "Wood Edwards";
        fetchPageContet(slug);
    }, [slug]);

    const fetchPageContet = async (slug) => {
        setIsFetching(true);
        try {
            const { data } = await axios.get(`/wp-admin/admin-ajax.php?action=get_pages_by_slug&page_slug=${slug}`);
            if (data?.page) {
                // if (data?.page?.yoast_title?.length > 0) {
                //     document.title = data?.page?.yoast_title;
                // } else {
                //     document.title = data?.page?.post_title ? `${data?.page?.post_title} - Wood Edwards` : "Wood Edwards";
                // }
                if (document.querySelector('#wp-admin-bar-edit a')) {
                    document.querySelector('#wp-admin-bar-edit a').innerText = `Edit Page`;
                    document.querySelector('#wp-admin-bar-edit a').href = `/wp-admin/post.php?post=${data?.page?.ID}&action=edit`;
                }
                setPageContent(data?.page ?? null);
            } else {
                navigate('/404');
            }
            
        } catch (err) {
            console.log(err);
        } finally {
            setIsFetching(false);            
        }
    }

    // Script Handler

    useEffect(() => {
        // Handle Content Embed Scripts
        const scriptRegex = /<script\b[^>]*>([\s\S]*?)<\/script>/gm;
        const scriptTags = [];

        let match;
        while ((match = scriptRegex.exec(pageContent?.post_content)) !== null) {
            scriptTags.push(match[0]);
        }

        const srcRegex = /src\s*=\s*["']([^"']+)["']/i;
        const srcAttributes = [];

        scriptTags.forEach(scriptTag => {
            const match = srcRegex.exec(scriptTag);
            if (match && match[1]) {
                srcAttributes.push(match[1]);
            }
        });

        let scripts = [];
        setTimeout(() => {
            scripts = srcAttributes.map(scriptUrl => {
                const script = document.createElement('script');
                script.src = scriptUrl;
                script.async = true;
                if (document.querySelector('div[data-bid="77409"]')) {
                    document.querySelector('div[data-bid="77409"]').appendChild(script);
                } else {
                    document.body.appendChild(script);
                }
                return script;
            });
        }, 500);
        
            // Cleanup: Remove scripts when component unmounts
        return () => {
            scripts.forEach(script => {
                try {
                    document.body.removeChild(script);
                } catch (err) {
                    console.log(err);
                }
            });
        };
    }, [pageContent])

    const generateRandomWidth = () => {
        // Generate a random width between 50% and 100%
        return `${Math.floor(Math.random() * 51) + 50}%`;
    };

    return <Fade delay={1}>
        <div className="default-page">
            <section id="banner" className="default-banner">
                <div className="inner-wrapper">
                    {!isFetching && <h1>{pageContent?.post_title}</h1>}
                    {isFetching && <h1><Skeleton width={generateRandomWidth()} /></h1>}
                </div>
            </section>

            <section id="default-page-container">
                <div className="inner-wrapper">
                    <div className="page-content">

                        {!isFetching && <article >
                            <div dangerouslySetInnerHTML={{__html: pageContent?.post_content }} />
                        </article>}
                        {
                            isFetching && <article>
                                {Array.from({length: 20}).map(it => <Skeleton width={generateRandomWidth()} height="20px" key={it} style={{marginTop: "5px"}} />)}
                            </article>
                        }
                    </div>
                </div>
            </section>
        </div>
    </Fade>
}

export default Default;